import { LinearGradient } from "expo-linear-gradient";
import { VStack } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

import BannerImage from "@/components/atoms/BannerImage";
import Carousel from "@/components/molecules/Carousel";
import { useAppNavigation } from "@/hooks/application/navigation";
import { Promotion } from "@/interfaces/domain/Promotion";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const cardWidth = 280;

type PromotionListProps = {
  data: Promotion[];
  isLoading: boolean;
};

const PromotionList = ({ data, isLoading }: PromotionListProps) => {
  const { navigate } = useAppNavigation<HomeNavigation>();

  const items = isLoading ? Array<Promotion>(4).fill(null) : data;

  return (
    <VStack zIndex={-1}>
      <Carousel
        data={items || []}
        itemLayout={cardWidth}
        onPressViewMore={() => navigate("promotions")}
        renderItem={({ item }) =>
          isLoading ? (
            <ShimmerCard />
          ) : (
            <BannerImage
              width={cardWidth + "px"}
              imageUrl={item.foto_promocao}
              onPress={() =>
                navigate("promotionProductList", {
                  storeId: item?.estabelecimento?._id,
                })
              }
            />
          )
        }
      />
    </VStack>
  );
};

const ShimmerCard = styled(ShimmerPlaceholder)`
  border-radius: 10px;
  width: ${cardWidth}px;
  height: 120px;
  margin: 10px;
`;

export default PromotionList;
